import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS } from '@mafc/common';
import { Box, Checkbox, Drawer, Flex } from '@mafc/trolly';

import CartListItem from '../CartListItem';
import { CartListItemVariant } from '../CartListItem/CartListItem.style';
import { ISubstitutesShipment } from 'pages/NewCart/ISubstitutes.types';

import * as S from './OOSSelectSubstitutesDrawer.style';

export const Title: React.FC<{}> = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Box fontWeight={[5, 6]} fontSize={[3, 6]} textAlign="center">
        {t('oosSubstitution.heading')}
      </Box>

      <Flex justifyContent="center">
        <S.ItemWrapper>{t('oosSubstitution.selectProductsForReplacement')} </S.ItemWrapper>
      </Flex>
    </Box>
  );
};

export const OOSSelectSubstitutesDrawer: React.FC<{
  isOpen: boolean;
  shipmentType: string;
  substitutesShipment?: ISubstitutesShipment;
  close: () => void;
  onContinue: (ids: number[]) => void;
}> = ({ isOpen, shipmentType, substitutesShipment, close, onContinue }) => {
  const { t } = useTranslation();

  const [substituteProductsSelectedStatus, setSubstituteProductsSelectedStatus] = useState<
    Record<string, boolean>
  >({});

  const onSubstituteItemChangeHandler = (code: string) => {
    setSubstituteProductsSelectedStatus((prevState: Record<string, boolean>) => {
      const selectedProducts = { ...prevState };
      selectedProducts[code] = !selectedProducts[code];
      return selectedProducts;
    });
  };

  const allSelectedProduct = useMemo(() => {
    return Object.keys(substituteProductsSelectedStatus)
      .filter((code: string) => substituteProductsSelectedStatus[code])
      .map(code => parseInt(code, 10));
  }, [substituteProductsSelectedStatus]);

  const onReplace = () => {
    onContinue(allSelectedProduct);
  };

  return (
    <Drawer
      onClose={close}
      isOpen={isOpen}
      width={[null, null, '480px']}
      anchor={['bottom', null, 'right']}
      contentStyles={{
        p: [0],
        pl: 5,
        pr: 5,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        color: COLORS.BLACK,
      }}
      containerStyles={{
        borderTopLeftRadius: [4, null, null, 0],
        borderTopRightRadius: [4, null, null, 0],
        height: ['85%', null, '100%'],
      }}
      preventCloseOnClickOutside={true}
      isTitleBorder={false}
      variant="float"
      title={<Title />}
    >
      {substitutesShipment &&
        substitutesShipment.eligibleItems &&
        substitutesShipment.eligibleItems.map(({ originalProduct: entry }, index) => {
          const { code } = entry.product;

          return (
            <S.CheckBoxLabel key={code} data-testid={`original-product-${code}`}>
              <Checkbox
                size={16}
                checkedBackground={COLORS.BLUE}
                checkMarkTint={COLORS.WHITE}
                onChangeCheckbox={onSubstituteItemChangeHandler.bind(null, code)}
                checked={!!substituteProductsSelectedStatus[code]}
              />
              <CartListItem
                entry={entry}
                shipmentType={shipmentType}
                isLoading={false}
                isOOSSubstitutionDrawer
                showQtySelector={false}
                variant={CartListItemVariant.DrawerItem}
              />
            </S.CheckBoxLabel>
          );
        })}
      <S.Footer>
        <S.ReplaceButton
          variant="secondary"
          size="CUSTOM"
          preventTextTransform
          disabled={allSelectedProduct.length === 0}
          onClick={onReplace}
          data-testid="replace-btn"
        >
          {`${t('cartShipment.replace')} (${allSelectedProduct.length})`}
        </S.ReplaceButton>
      </S.Footer>
    </Drawer>
  );
};
